import React from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/styles';
import Translator from 'translator';
import { Fab, Tooltip } from '@material-ui/core';
import { Print as PrintIcon } from '@material-ui/icons';
import { tools } from 'data/common';

const propTypes = {
    boxId: PropTypes.number,
    codeEnv: PropTypes.number.isRequired,
    codePack: PropTypes.number.isRequired,
    envBox: PropTypes.string.isRequired,
    boxMac: PropTypes.string.isRequired,
    disabled: PropTypes.bool
};

const defaultProps = {
    boxId: null,
    disabled: false
};

const BtnPrintEtiquette = props => {
    const { boxId, disabled, codeEnv, codePack, envBox, boxMac } = props;
    const classes = useStyles(props);

    const openPrintTab = () => {
        tools.printLabel({ boxId, codeEnv, codePack, envBox, boxMac });
    };

    return (
        <Tooltip title={`${Translator.translate(`testbench.buttons.printIcon`)}`} placement="top" disableHoverListener={disabled}>
            <span className={classes.printIcon}>
                <Fab aria-label="Print" onClick={openPrintTab} size="small" disabled={disabled || !boxId}>
                    <PrintIcon color="primary" className={classes.icon} />
                </Fab>
            </span>
        </Tooltip>
    );
};

const useStyles = makeStyles(theme => ({
    printIcon: {
        minHeight: 30,
        minWidth: 30
    },
    icon: {
        [theme.breakpoints.down('xs')]: {
            fontSize: '1.2rem'
        }
    }
}));

BtnPrintEtiquette.propTypes = propTypes;
BtnPrintEtiquette.defaultProps = defaultProps;

export default BtnPrintEtiquette;



// WEBPACK FOOTER //
// ./data/components/BtnPrintEtiquette.js